import { each, isArray, isBoolean } from "lodash";
import { get, isEmpty, isFunction, isUndefined } from "lodash-es";
import { translation } from "./translator";
import { transform } from "./validator";

export const getFieldByKey = (fields, key) => {
  let target = null;
  each(fields, (f) => {
    if (!target) {
      if (f.key === key) {
        target = f;
      } else if (isArray(f)) {
        target = getFieldByKey(f, key);
      }
    }
  });
  return target;
};

export const getValue = (field, data, _transform) => {
  let value = "";
  let valueItem = get(data, field.key);

  if (field.onTranslator) {
    value = translation(
      field.onTranslator.list,
      valueItem,
      field.onTranslator.value,
      field.onTranslator.label
    );
  } else {
    value = !isEmpty(valueItem) ? valueItem : "";
  }

  if (field.onValue) {
    value = field.onValue(value || valueItem, field, data);
  } else if (!field.onTranslator) {
    value = !isUndefined(valueItem) ? valueItem : field.label;
  }
  if (_transform) {
    value = transform(value, _transform)
  }
  return value;
};

export const getDisabled = (field, data, form) => {
  let isDisabled =
    (isBoolean(get(field, "isDisabled") && get(field, "isDisabled")) || get(field, "disabled")) || get(field, "options.disabled") || false;
  if (
    field.isDisabled &&
    isFunction(field.isDisabled)
  ) {
    isDisabled = field.isDisabled({ data, form });
  }
  return isDisabled;
};

// obj 는 field 일수도있고 form일수도있음
// list 를 가져오거나 기본 값을 가져오는 용도
export const getData = async (obj, key) => {
  let data = get(obj, key);
  if (isFunction(data)) {
    data = await data();
  }
  return data;
};

export const isCustomDatePicker = ({ type = "" }) => {
  return type.toLocaleLowerCase() === "customdatepicker";
};

export const isCheckBox = ({ type = "" }) => {
  return type.toLocaleLowerCase() === ("checkbox" || "checkbexes");
};

export const pickerDefaultOptions = {
  placeholder: "YYYY.MM.DD",
  options: {
    altInput: true,
    altFormat: "Y.m.d",
    dateFormat: "Y-m-d",
  },
};

export const timepickerDefaultOptions = {
  time_24hr: true,
  enableTime: true,
  noCalendar: true,
  dateFormat: "H:i",
  minuteIncrement: 1,
};
